import { useTranslation } from "react-i18next";
import { DatePickerInput } from "../../../components/DatePickerInput";
import { IDateIntervalFilterProps } from "../../../interfaces";
import { PRESETS, PresetsEnum } from "../../../utils/constants";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import { useClickOutside } from "../../../hooks/ClickOutsideHook";

const customPresetIndex = PRESETS.findIndex(e => e.Id === PresetsEnum.Custom);

export const GaDateIntervalFilter = ({ Interval, preset, onChange }: IDateIntervalFilterProps) => {
	const { t } = useTranslation("general");
	const [ref, viewPreset, setViewPreset] = useClickOutside<HTMLDivElement>();

	const handlePresetChange = (value: string) => {
		const number = Number(value);

		onChange(PRESETS[number].Interval, number);
        setViewPreset(!viewPreset);
	};

	const handleDateChange = (key: "PeriodStart" | "PeriodEnd", value: any) => {
		if (Interval[key] === value)
			return;

		onChange({ ...Interval, [key]: value }, customPresetIndex);
	};

	function handlePresetClick(): void {
		setViewPreset(!viewPreset);
	}

	return (
		<>
			<div ref={ref} className="ga-form-field ar-ga-dropdown">
				<label className="ga-form-field__label">
					<span className="ga-form-field__label-text">{t("Preset")}</span>
				</label>
				<button type="button" className="ga-select ar-w-175" onClick={handlePresetClick}>
					<div className="ga-select__value">{t(PRESETS[preset].Id)}</div>
					{!viewPreset && <ChevronDownIcon className="ga-select__arrow" size={16} />}
					{viewPreset && <ChevronUpIcon className="ga-select__arrow" size={16} />}
				</button>
				{viewPreset &&
					<div className="ga-dropdown">
						{PRESETS.map((presetItem, index) => (
							<button
								key={presetItem.Id}
								className={`ga-dropdown__item ${presetItem.Id === PRESETS[preset].Id ? "ga-dropdown__item--selected" : ""}`}
								onClick={() => handlePresetChange(index.toString())}
								type="button"
							>
								<div className="ga-dropdown__item-label">{t(presetItem.Id)}</div>
							</button>
						))}
					</div>
				}
			</div>
            <div className="ga-form-field">
                <label className="ga-form-field__label">
                    <span className="ga-form-field__label-text">{t("From")}</span>
                </label>
                <div data-testid="report-filter-from">
					<DatePickerInput value={Interval.PeriodStart} onChange={(date) => handleDateChange("PeriodStart", date)} />
				</div>
            </div>
			<div className="ga-form-field">
                <label className="ga-form-field__label">
                    <span className="ga-form-field__label-text">{t("To")}</span>
                </label>
                <div data-testid="report-filter-to">
					<DatePickerInput value={Interval.PeriodEnd} onChange={(date) => handleDateChange("PeriodEnd", date)} />
				</div>
            </div>
		</>
	)
}